// Generic render-hold slot: lets a domain module redirect an authenticated user
// (e.g. unfinished-signup → funnel) from inside the app shell without app-shell
// depending on that domain. The domain registers its hook at module load — before
// LogInRequired first renders — so the hook count stays stable across renders.
//
// app-shell is the dependency-bottom layer and must not import module-owned
// domains; this inverts the dependency (the billing module registers into the
// shell instead of the shell importing billing).

let authRedirectGateHook: () => boolean = () => false

/** Register the hook the shell calls to decide whether to hold rendering while a
 * domain redirect is pending. Call at module load (see modules/billing). */
export function registerAuthRedirectGate(hook: () => boolean): void {
  authRedirectGateHook = hook
}

/** True while a registered domain gate is redirecting; the shell holds rendering. */
export function useAuthRedirectGate(): boolean {
  return authRedirectGateHook()
}
